import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachLopTinChiiActionsObj } from "../../action-types/lop-tin-chi/IDanhSachLopTinChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachLopTinChiActions = {
  ...generateActions(eDanhSachLopTinChiiActionsObj, "DANH_SACH_LOP_TIN_CHI"),
  ...generateActionForKey(
    eDanhSachLopTinChiiActionsObj,
    "DANH_SACH_LOP_TIN_CHI",
    "EXPORT_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDanhSachLopTinChiiActionsObj,
    "DANH_SACH_LOP_TIN_CHI",
    "EXPORT_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
};
